import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../component/shared/shared.service";
import { Tag } from "../model/tag";
import { TagMasterService } from "../services/tag-master.service";
import {
  DialogAction,
  ActionMessage
} from "../../../shared/enum/dialog-action.enum";
@Component({
  selector: "app-tag",
  templateUrl: "./tags.component.html",
  styleUrls: ["./tags.component.css"]
})
export class TagComponent implements OnInit {
  srvData: Tag = new Tag(null, "", "", null);
  loading: boolean = false;
  listLoading: boolean = false;
  message: string = "";
  isAdd: boolean = true;
  Tags: Tag[];
  selectedObject: Tag;
  user: any;
  constructor(
    private _sharedService: SharedService,
    private _srvService: TagMasterService
  ) {
    this.isAdd = true;
    _sharedService.yesEmitted$.subscribe(text => {
      if (
        text.Action === DialogAction.DELETE.toString() &&
        text.Page === "Tag"
      ) {
        this.delete();
      } else {
        this.clearData();
      }
    });
  }

  getTagDetail(): void {
    this.listLoading = true;
    this._srvService.getTags().subscribe(
      data => {
        this.listLoading = false;
        this.Tags = data;
      },
      error => {}
    );
  }
  clearData(): void {
    this.srvData.TagId = null;
    this.srvData.TagText = "";
    this.isAdd = true;
  }
  cancelData(): void {
    if (this.isAdd) {
      this.clearData();
    } else {
      this._sharedService.emitDialog(
        true,
        "Cancel",
        ActionMessage.CANCEL.toString(),
        true,
        DialogAction.CANCEL.toString(),
        "Tag"
      );
    }
  }
  editTag(srvEditObject: Tag): void {
    this.isAdd = false;
    this.srvData = Object.assign(Object.create(srvEditObject), srvEditObject);
  }
  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));
    this.getTagDetail();
  }
  saveTag(): void {
    this.loading = true;
    this._srvService.data = this.srvData;
    if (this.isAdd) {
      this.addTag();
    } else {
      this.updateTag();
    }
  }
  addTag(): void {
    this._srvService.saveTag().subscribe(
      data => {
        this.loading = false;
        this.message = "Tag " + ActionMessage.SAVESUCCESS.toString();
        this.clearData();
        this.getTagDetail();
        this.hideMessage();
      },
      error => {
        this.loading = false;
        if (error.data !== undefined) {
          this.message = error.data;
        } else {
          this.message = JSON.parse(error._body).Message;
        }
        this.hideMessage();
      }
    );
  }
  updateTag(): void {
    this._srvService.updateTag().subscribe(
      data => {
        this.loading = false;
        this.message = "Tag " + ActionMessage.UPDATESUCCESS.toString();
        this.clearData();
        this.getTagDetail();
        this.hideMessage();
      },
      error => {
        this.loading = false;
        if (error.data !== undefined) {
          this.message = error.data;
        } else {
          this.message = JSON.parse(error._body).Message;
        }
        this.hideMessage();
      }
    );
  }
  delete(): void {
    this.listLoading = true;
    this._srvService.deleteTag(this.selectedObject).subscribe(
      data => {
        this.listLoading = false;
        this.message = "Tag " + ActionMessage.DELETESUCCESS.toString();
        this.clearData();
        this.getTagDetail();
        this.hideMessage();
      },
      error => {
        this.listLoading = false;
        if (error.data !== undefined) {
          this.message = error.data;
        } else {
          this.message = JSON.parse(error._body).Message;
        }
        this.hideMessage();
      }
    );
  }
  hideMessage(): void {
    setTimeout(() => {
      this.message = "";
    }, 1000);
  }
  deletTag(org: Tag): void {
    this.selectedObject = org;
    this._sharedService.emitDialog(
      true,
      "Delete",
      ActionMessage.DELETE.toString(),
      true,
      DialogAction.DELETE.toString(),
      "Tag"
    );
  }
  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/section/master/tags/tags.component.ts